import React from 'react';
import './LoginWrapper.css';
import {AppLogo, Link} from 'components/core';
import settings from 'controllers/settings';
import { Alert, AlertTitle } from '@material-ui/lab';
import { Grid, Collapse, IconButton, Typography, Paper } from '@material-ui/core';
import {ExpandMore, ExpandLess} from '@material-ui/icons';


function ServerTypeWarning()
{
    const [openInfo, setOpenInfo] = React.useState(true);

    return <>
    {settings.server === "development" ? 
        <Alert severity="warning" variant="filled" style={{padding: "0 48px"}}>SERVIDOR DE DESARROLLO</Alert>
    : ""}
    {settings.server === "localhost" ? 
        <Alert severity="success" variant="filled" style={{padding: "0 48px"}}>SERVIDOR LOCALHOST</Alert>
    : ""}
    {settings.server === "demo" ? 
        <Collapse in={openInfo} collapsedHeight={40}>
        <Alert severity="info" variant="standard">
            <AlertTitle>
                Servidor de Demostración
                <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                        setOpenInfo(!openInfo);
                    }}
                >
                    {openInfo ? <ExpandLess fontSize="inherit" /> : <ExpandMore fontSize="inherit" /> }
                </IconButton>
            </AlertTitle>
            Está en el <b>servidor demostrativo</b> de la plataforma Cableo. <br></br>
            Para acceder puede utilizar los siguientes usuarios: <br></br>
            <br></br>
            <b>operator@demo.com</b> - para utilizar Cableo como un operario<br />
            <b>expert@demo.com</b> - para utilizar Cableo como un experto<br />
            <b>admin@demo.com</b> - para ver las opciones de administración<br />
            <p />
            Tenga en cuenta que el servidor demostrativo <b>se regenera cada hora en punto</b> y se borrará todo lo que se haya hecho.<br />
            Otros usuarios pueden estar usando el servidor demostrativo a la vez que usted.
        </Alert>
        </Collapse>
    : ""}
    </>
}


function LoginWrapper(props)
{
    return (<>
            <div className="loginBody">
                <div className="loginContent">
                    <Grid className="loginContent" container
                    direction="column"
                    spacing={2}
                    justify="center"
                    alignItems="stretch"
                    >
                        <Grid item>
                                <ServerTypeWarning />
                        </Grid>
                        <Grid item>
                            <Paper className="loginCard" elevation={0}>
                                <Grid
                                    container
                                    direction="column"
                                    justify="center"
                                    alignItems="stretch"
                                    spacing={2}
                                >
                                    <Grid item><AppLogo width="109" /></Grid>
                                    <Grid item>{props.children}</Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                        <Grid 
                            className="loginCardFooter"
                            container
                            item
                            direction="row"
                            justify="space-between"
                            alignItems="center"
                            spacing={0}
                        >
                            <Grid item xs={4}><Link href="https://pixels-hub.com" color="textPrimary">Powered by <img className="pixelsHubLogo" src="/PixelsHubInline.png" alt="pixels-hub logo" /></Link></Grid>
                            <Grid item xs={4}><Link href="https://pixels-hub.com/contacto" color="textPrimary">Contacto</Link></Grid>
                            <Grid item xs={4}><Link href="https://help.cableo.es/#/privacy" color="textPrimary">Política de Privacidad</Link></Grid>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </>
    );    
}

    

export default LoginWrapper;
    